import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import useBlogHomePage from 'components/consumer/blog/hooks/useBlogHomePage';
import AboveTheFoldServerRenderer from 'components/essentials/AboveTheFoldServerRenderer';
import FeaturedBlog from './components/FeaturedBlog/FeaturedBlog';
import CategoryPost from './components/CategoryPost/CategoryPost';
const BlogHome = t0 => {
  const $ = _c(16);
  const {
    blogUrl,
    slug
  } = t0;
  let t1;
  if ($[0] !== blogUrl) {
    t1 = {
      blogUrl
    };
    $[0] = blogUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    loading,
    data,
    error
  } = useBlogHomePage(t1);
  if (loading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Placeholder type="rect" loading={true} />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (error) {
    let t2;
    if ($[3] !== error) {
      t2 = <div>{error}</div>;
      $[3] = error;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== data) {
    t2 = data || {};
    $[5] = data;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    featuredPostsConfig,
    categoryPosts
  } = t2;
  const t3 = `${slug}blog-home-wrapper`;
  let t4;
  if ($[7] !== featuredPostsConfig) {
    t4 = featuredPostsConfig && <FeaturedBlog config={featuredPostsConfig} />;
    $[7] = featuredPostsConfig;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== blogUrl || $[10] !== categoryPosts) {
    t5 = categoryPosts?.length > 0 && <div className="pl-5 pr-5 mx-auto my-0 md:pl-[3.333vw] md:pr-[3.333vw]">{categoryPosts.map((categoryPost, i) => <AboveTheFoldServerRenderer key={categoryPost.slug} componentIndex={i + 5}><CategoryPost blogUrl={blogUrl} category={categoryPost} /></AboveTheFoldServerRenderer>)}</div>;
    $[9] = blogUrl;
    $[10] = categoryPosts;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <Fragment key={t3}>{t4}{t5}</Fragment>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
BlogHome.propTypes = {
  blogUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired
};
export default BlogHome;